import axios from "axios";

export const PUBLIC_NOTICE_URL = "/PublicNotice";

/** Belli Bir Genel Duyuru (Okul Duyurusu) Listesini Elde Eder */
export function getPublicNotices(queryParams) {
  return axios.post(`${PUBLIC_NOTICE_URL}/GetPublicNotices`, queryParams);
}

/** Belli Bir Genel Duyuru (Okul Duyurusu) Listesini Sayfalama Olmadan Elde Eder */
export function getAllPublicNotices(queryParams) {
  return axios.post(`${PUBLIC_NOTICE_URL}/GetAllPublicNotices`, queryParams);
}

/** Yeni Bir Genel Duyuruyu (Okul Duyurusu) Elde Eder */
export function getNewPublicNotice() {
  return axios.get(PUBLIC_NOTICE_URL);
}

/** Belli Bir Genel Duyurunun (Okul Duyurusu) Detaylarını Elde Eder */
export function getPublicNotice(id) {
  return axios.get(`${PUBLIC_NOTICE_URL}/${id}`);
}

/** Belli Bir Genel Duyurunun (Okul Duyurusu) Ekini İndirir */
export function downloadAttachment(id) {
  return axios.get(`${PUBLIC_NOTICE_URL}/DownloadAttachment/${id}`, { responseType: "blob" });
}

/** Belli Bir Genel Duyuruyu (Okul Duyurusu) Kaydeder */
export function savePublicNotice(publicNotice) {
  return axios.post(PUBLIC_NOTICE_URL, publicNotice);
}

/** Belli Bir Genel Duyuru (Okul Duyurusu) Listesini Siler */
export function deletePublicNotices(ids) {
  return axios.post(`${PUBLIC_NOTICE_URL}/Delete`, ids);
}